<script>
  import { env } from '$env/dynamic/public';
  export let landingPageModel;
  let { seo, index } = landingPageModel;
</script>

<svelte:head>
  {#if env.PUBLIC_NODE_ENV !== 'production'}
    <meta name="robots" content="noindex, nofollow" />
  {/if}

  <title>{seo.title || index.title}</title>
  <meta property="og:title" content={seo.title || index.title} />
  <link rel="icon" href={seo?.favIcon} />
  <meta
    name="description"
    content={seo.description ||
      'Check out my new website, built effortlessly using AI with voolt.com! Give it a try for FREE!'}
  />
  <meta
    property="og:description"
    content={seo.description ||
      'Check out my new website, built effortlessly using AI with voolt.com! Give it a try for FREE!'}
  />

  {#if seo?.keywords}
    <meta name="keywords" content={seo?.keywords} />
  {/if}
  {#if seo?.image}
    <meta property="og:image" content={seo?.image} />
  {/if}
  <meta property="og:type" content="website" />
</svelte:head>
